module.exports = __webpack_public_path__ + "img/start@mob.0bd850ad.webp";